import { useTranslations } from "next-intl";
import CustomSelect from "./CustomSelect";

type PropsType = {
  allProductsCount: number;
  showingProductsCount: number;
  sortBy?: string;
};

export default function TopBar({
  allProductsCount,
  showingProductsCount,
  sortBy,
}: PropsType) {
  const t = useTranslations();
  return (
    <div className="flex flex-wrap items-center gap-4 ml-3 min-w-0">
      {/*<CustomSelect />*/}

      <p className="text-sm sm:text-base">
        {t("Products.showing", {
          current: showingProductsCount,
          total: allProductsCount,
          count: showingProductsCount,
        })}
      </p>
    </div>
  );
}
